import { CheckCircleFilled, CloseCircleFilled } from "@ant-design/icons";
import { Tag } from "antd";
import {
  ProductionCodeRequestDetails,
  ProductionCodeRequestFormPayload,
  ProductionCodeRequestStatus,
} from "./productionCode.types";

export const mapDetailsToFormMode = (
  details: ProductionCodeRequestDetails | undefined
): ProductionCodeRequestFormPayload | undefined => {
  if (!details) {
    return undefined;
  }

  return {
    masinaId: details?.masinaId,
    ukljuceneMasine: details?.ukljuceneMasine,
    brojCigaretaUPojedinacnomPakovanju:
      details?.brojCigaretaUPojedinacnomPakovanju,
    duvanskiProizvodVrstaId: details?.duvanskiProizvodVrstaId,
    objekatId: details?.objekatId,
    oznakaKn: details?.oznakaKn,
    prosecnaBrutoMasaJedinicnogPakovanja:
      details?.prosecnaBrutoMasaJedinicnogPakovanja,
    robnaMarkaId: details?.robnaMarkaId,
    tipObveznikaId: details?.tipObveznikaId,
    trazenaKolicinaJedinstvenihOznakaPojedinacnogPakovanja:
      details?.trazenaKolicinaJedinstvenihOznakaPojedinacnogPakovanja,
    brojZahteva: details?.brojZahteva,
  } as ProductionCodeRequestFormPayload;
};

export const renderPlacenTag = (status: boolean | null) => {
  return status ? (
    <CheckCircleFilled style={{ color: "#0cad65", fontSize: 20 }} />
  ) : (
    <CloseCircleFilled style={{ color: "#ed7373", fontSize: 20 }} />
  );
};

export const renderStatusTag = (
  status: ProductionCodeRequestStatus | undefined,
  text: string | null | undefined
) => {
  if (!status) {
    return null;
  }
  switch (status) {
    case ProductionCodeRequestStatus.KREIRAN:
      return <Tag color="blue">{text}</Tag>;
    case ProductionCodeRequestStatus.ODBIJEN:
      return <Tag color="error">{text}</Tag>;
    case ProductionCodeRequestStatus.PRIHVACEN:
      return <Tag color="green">{text}</Tag>;
    case ProductionCodeRequestStatus.U_OBRADI:
      return <Tag color="warning">{text}</Tag>;
    default:
      return <Tag color="default">{text}</Tag>;
  }
};
